<template>
  <form
    v-show="isShow"
    :class="{ formClass: isShow }"
    @submit.prevent="registerSubmit"
    @keydown="registerform.errors.clear($event.target.name)"
    class="pb-2"
  >
    <div class="desc text-center">
      <p v-if="registerform.errors.any()" class="text-danger">
        გთხოვთ შეიყვანოთ სწორი მონაცმები
      </p>
      <p v-else>გთხოვთ გაიროთ რეგისტრაცია!</p>
    </div>
    <div class="signUp">
      <div v-if="universities.length" class="form-group">
        <label for="">სად გინდა ჩაბარება?</label>
        <v-select
          multiple
          @input="registerform.errors.clear('universities')"
          name="universities"
          :reduce="(item) => item.id"
          label="title"
          :options="universities"
          v-model="registerform.universities"
          :selectable="(o) => !registerform.universities.includes(o.id)"
        />
        <p class="text-danger font-12" v-if="registerform.errors.has('universities')">
          {{ registerform.errors.get('universities') }}
        </p>
      </div>

      <div v-if="universities.length" class="form-group">
        <label for="">რომელ კლასში ხარ?</label>
        <v-select
          @input="registerform.errors.clear('grade')"
          name="grade"
          :reduce="(item) => item.id"
          label="title"
          :options="grades"
          v-model="registerform.grade"
        />
        <p class="text-danger font-12" v-if="registerform.errors.has('grade')">
          {{ registerform.errors.get('grade') }}
        </p>
      </div>
      <span>
        <input
          type="text"
          v-model="registerform.name"
          class="form"
          placeholder="სახელი"
          name="name"
          autocomplete="off"
        />
        <span class="underline"></span>

        <p class="text-danger mt-m-20" v-if="registerform.errors.has('name')">
          {{ registerform.errors.get('name') }}
        </p>
      </span>

      <span>
        <input
          v-model="registerform.phone"
          class="form"
          placeholder="მობილური"
          name="phone"
          autocomplete="off"
        />
        <span class="underline"></span>

        <p
          class="text-danger mt-m-20"
          v-if="
            registerform.errors.has('phone') &&
            registerform.errors.get('phone') == 'ასეთი მობილური უკვე არსებობს.'
          "
        >
          ეს მობილურით უკვე გამოყენებულია,
          <span @click="passwordReset = !passwordReset" class="fbcolor pointer">
            თუ ეს მობილურით თქვენ გეკუთნით პარილის გასანახლებლად დააჭირეთ აქ
          </span>
        </p>

        <p v-else-if="registerform.errors.has('phone')" class="text-danger mt-m-20">
          {{ registerform.errors.get('phone') }}
        </p>
      </span>

      <span>
        <input
          type="password"
          v-model="registerform.password"
          class="form"
          placeholder="პაროლი"
          name="password"
          autocomplete="off"
        />
        <span class="underline"></span>

        <p class="text-danger mt-m-20" v-if="registerform.errors.has('password')">
          {{ registerform.errors.get('password') }}
        </p>
      </span>
    </div>
    <div class="text-center">
      <button
        type="submit"
        :class="{ regsending: sending }"
        :disabled="registerform.errors.any()"
        class="b-shadow-none btn btn-primary btn-link btn-lg"
      >
        გაგაზავნა
        <i class="fas fa-paper-plane"></i>
      </button>
    </div>
    <button @click="$emit('changeForm')" type="button" class="btn btn-light btn-block regBtn">
      ავტორიზაცია
    </button>
  </form>
</template>

<script>
import vSelect from 'vue-select';
import { Form } from '../../../form/form.js';
import { UniService } from '../../../services/uni.http';
export default {
  props: ['unauth', 'isShow'],
  components: {
    vSelect,
  },
  data() {
    return {
      universities: [],
      grades: [
        {
          title: 'XII კლასი',
          id: 12,
        },
        {
          title: 'XI კლასი',
          id: 11,
        },
        {
          title: 'X კლასი',
          id: 10,
        },
        {
          title: 'IX კლასი',
          id: 9,
        },
        {
          title: 'არ ვარ მოსწავლე',
          id: 0,
        },
      ],
      password_msg: false,
      sending: false,
      login: true,
      passwordReset: false,
      registerform: new Form({
        name: '',
        phone: '',
        password: '',
        grade: null,
        universities: [],
      }),
    };
  },
  methods: {
    registerSubmit() {
      this.sending = true;
      axios
        .post('/myregister', this.registerform.data())
        .then((res) => {
          if (res.data.linkto) return (window.location.href = res.data.linkto);
          location.reload();
        })
        .catch((error) => {
          this.sending = false;
          this.registerform.errors.record(error.response.data.errors);
        });
    },
  },
  mounted() {
    UniService.all().then((res) => {
      this.universities = res.data.universities;
    });
  },
};
</script>
